import { render } from "./Regulations.vue?vue&type=template&id=d78ab05c&scoped=true"
import script from "./Regulations.vue?vue&type=script&lang=js"
export * from "./Regulations.vue?vue&type=script&lang=js"

import "./Regulations.vue?vue&type=style&index=0&id=d78ab05c&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78ab05c"]])

export default __exports__